/* src/app/app.component.scss */
.container {
  margin-top: 72px;
}
h1 {
  font-size: 1.2em;
  margin-bottom: 0;
}
h2 {
  font-size: 2em;
  margin-top: 0;
  padding-top: 0;
}
nav a {
  padding: 5px 10px;
  text-decoration: none;
  margin-top: 10px;
  display: inline-block;
  background-color: #eee;
  border-radius: 4px;
}
nav a:visited,
a:link {
  color: #334953;
}
nav a:hover {
  color: #039be5;
  background-color: #cfd8dc;
}
nav a.active {
  color: #039be5;
}
.footer {
  position: relative;
  padding: 11px 0;
  background-color: #000;
  font-size: 12px;
  text-align: right;
  color: #999;
}
.nav {
  margin: 0;
  padding: 0 0 0 60px;
  display: flex;
  list-style: none;
}
.nav li {
  margin-left: 1em;
}
.nav li:first-of-type {
  margin-left: 0;
}
.nav a {
  color: #999;
  text-decoration: none;
}
.nav a:hover {
  text-decoration: underline;
}
.copyright {
  position: absolute;
  top: 50%;
  width: 100%;
  max-width: 1400px;
}
.copyright p {
  position: absolute;
  right: 70px;
  transform: translateY(-50%);
  margin: 0 auto;
}
@media screen and (max-width: 1024px) {
  .copyright {
    width: auto;
    position: initial;
  }
  .footer p {
    position: initial;
    text-align: center;
    transform: unset;
  }
}
/*# sourceMappingURL=app.component-AYSNAD6I.css.map */
